export enum SubscriptionProductType {
    PlatformResearch = "PlatformResearch"
  }